import { atom, selector } from "recoil";

export const CardHeight = atom({
    key: "CardHeight",
    default: 250,
  }),
  CardWidth = selector({
    key: "CardWidth",
    get: ({ get }) => get(CardHeight) / 1.25,
  }),
  DragCard = atom({
    key: "DragCard",
    default: null,
  });

export function getDeck() {
  const cards = [],
    deck = [],
    getIndex = () => Math.floor(Math.random() * cards.length);

  for (let r = 1; r < 14; r++) {
    for (let s = 1; s < 5; s++) {
      cards.push({ rank: r, suit: s });
    }
  }

  while (cards.length) {
    const index = getIndex();

    deck.push(cards[index]);
    cards.splice(index, 1);
  }

  return deck;
}
